export const InventoryWarehouses = {
  en: {
    Warehouses: 'Warehouses',
    Warehouse: 'Warehouse',
    'All warehouses': 'All warehouses',
    'Create Warehouse': 'Create Warehouse',
    'Update Warehouse': 'Update Warehouse',
    'New Warehouse': 'New Warehouse',
    'Add warehouse': 'Add warehouse',
    'Edit Warehouse': 'Edit Warehouse',
    Location: 'Location',
    'Responsible persons': 'Responsible persons',
    'Responsible persons hint':
      'Optional. Employees responsible for the stock of this warehouse; stock-count shortages are attributed to them. If empty, a shortage stays a company expense.',
    Dismissed: 'Dismissed',
    'Sale method': 'Sale method',
    'Sale from warehouse': 'Sale from warehouse',
    'Sale from warehouse hint':
      'Goods can be sold from this warehouse: always by whole packages, and by portions when the product has a portion price.',
    'Whole packages only': 'Goods by packages only',
    'Whole packages only hint':
      'Goods on this warehouse are received, written off, transferred and sold in whole packages only. Portions are not available.',
    'Enabled categories': 'Enabled categories',
    'Enabled categories hint':
      'Categories are shared by all warehouses of the company. Only products of the checked categories can be received, stored, transferred to and sold from this warehouse. A category created here is enabled on this warehouse only.',
    'Add Category': 'Category',
    'New Category': 'New Category',
    'New Subcategory': 'New Subcategory',
    'Create subcategory': 'Create subcategory',
    'Parent category': 'Parent category',
    'Category name': 'Category name',
    Rename: 'Rename',
    'Rename Category': 'Rename Category',
    'Category depth hint': 'Categories can be nested up to 3 levels.',
    'Select a warehouse to create a category':
      'Select a specific warehouse to create a category',
    'Select a warehouse to manage it':
      'Select a specific warehouse to edit or archive it',
    'No categories': 'No categories yet',
    'Expand all': 'Expand all',
    'Collapse tree': 'Collapse',
    'Add product': 'Add product',
    'Show archived': 'Show archived',
    'Search categories': 'Search categories',
    'Search product or SKU': 'Search product or SKU',
    'All products': 'All products',
    'New Product': 'New Product',
    'Create Product': 'Create Product',
    'Edit Product': 'Edit Product',
    'Update Product': 'Update Product',
    Type: 'Type',
    'Product type hint':
      'A kit has no stock of its own: selling it writes off its components. The type cannot be changed later.',
    Category: 'Category',
    'Business direction': 'Business direction',
    SKU: 'SKU',
    Package: 'Package',
    'Package size': 'Package size',
    'Package size hint':
      'Cannot be changed after the first warehouse operation with this product. To change it, create a new product.',
    Unit: 'Unit',
    'Package price': 'Package price',
    Portion: 'Portion',
    'Portion description':
      'Sell the product by portions as well as by whole packages.',
    'Portion hint':
      'To sell single pieces from a pack, set the portion to 1 pc.',
    'Portion size': 'Portion size',
    'Portion price': 'Portion price',
    'Critical quantity': 'Critical quantity',
    'Critical quantity hint':
      'Checked on every warehouse separately: below it, the product is marked for reordering.',
    Quantity: 'Quantity',
    'Image hint': 'JPG, PNG or WEBP up to 5 MB; shown in the product list.',
    Consignment: 'Consignment',
    'Consignment description':
      'The supplier keeps ownership of the goods; you pay for what is sold at the supplier price.',
    Supplier: 'Supplier',
    'Supplier price': 'Supplier price (per package)',
    'Supplier price hint':
      'The price per package set by the supplier. Our debt for sold or lost consignment goods is calculated at the price valid at that moment.',
    'Purchase price': 'Purchase price',
    'Purchase price description':
      'Average cost per package, calculated from receipts and stock. Changes only through warehouse operations.',
    'Sale price': 'Sale price',
    'In Package': 'In package',
    Product: 'Product',
    'Kit items': 'Kit contents',
    'Add Kit Item': 'Add product',
    'Remove Kit Item': 'Remove product',
    'Kit item search': 'Search by name or SKU',
    'Kit price': 'Kit price',
  },
  uk: {
    Warehouses: 'Склади',
    Warehouse: 'Склад',
    'All warehouses': 'Всі склади',
    'Create Warehouse': 'Створити склад',
    'Update Warehouse': 'Оновити склад',
    'New Warehouse': 'Новий склад',
    'Add warehouse': 'Додати склад',
    'Edit Warehouse': 'Редагування складу',
    Location: 'Локація',
    'Responsible persons': 'Відповідальні особи',
    'Responsible persons hint':
      "Необов'язково. Працівники, відповідальні за залишки цього складу; на них відноситься недостача за інвентаризацією. Якщо не вказано — недостача залишається витратою компанії.",
    Dismissed: 'Звільнений',
    'Sale method': 'Спосіб продажу',
    'Sale from warehouse': 'Продаж зі складу',
    'Sale from warehouse hint':
      'З цього складу можна продавати товари: завжди цілими упаковками, а порціями — якщо в товару вказана ціна порції.',
    'Whole packages only': 'Товари тільки по упаковкам',
    'Whole packages only hint':
      'Товари на цьому складі оприбутковуються, списуються, переміщуються та продаються лише цілими упаковками. Порції недоступні.',
    'Enabled categories': 'Увімкнені категорії',
    'Enabled categories hint':
      'Категорії спільні для всіх складів компанії. Лише товари відмічених категорій можна оприбуткувати, зберігати, переміщувати на цей склад і продавати з нього. Категорія, створена тут, вмикається лише на цьому складі.',
    'Add Category': 'Категорія',
    'New Category': 'Нова категорія',
    'New Subcategory': 'Нова підкатегорія',
    'Create subcategory': 'Створити підкатегорію',
    'Parent category': 'Батьківська категорія',
    'Category name': 'Назва категорії',
    Rename: 'Перейменувати',
    'Rename Category': 'Перейменування категорії',
    'Category depth hint': 'Категорії можна вкладати до 3 рівнів.',
    'Select a warehouse to create a category':
      'Оберіть конкретний склад, щоб створити категорію',
    'Select a warehouse to manage it':
      'Оберіть конкретний склад, щоб редагувати або архівувати його',
    'No categories': 'Категорій ще немає',
    'Expand all': 'Розгорнути все',
    'Collapse tree': 'Згорнути',
    'Add product': 'Додати товар',
    'Show archived': 'Показати архівні',
    'Search categories': 'Пошук категорії',
    'Search product or SKU': 'Пошук товару або артикулу',
    'All products': 'Усі товари',
    'New Product': 'Новий товар',
    'Create Product': 'Створити товар',
    'Edit Product': 'Редагування товару',
    'Update Product': 'Оновити товар',
    Type: 'Тип',
    'Product type hint':
      'Набір не має власного залишку: при продажу списуються його складові. Тип не можна змінити пізніше.',
    Category: 'Категорія',
    'Business direction': 'Напрямок діяльності',
    SKU: 'Артикул',
    Package: 'Упаковка',
    'Package size': 'Розмір упаковки',
    'Package size hint':
      'Не можна змінити після першої складської операції з цим товаром. Для зміни створіть новий товар.',
    Unit: 'Одиниця',
    'Package price': 'Ціна упаковки',
    Portion: 'Порція',
    'Portion description':
      'Продавати товар порціями, а не лише цілими упаковками.',
    'Portion hint': 'Щоб продавати поштучно з упаковки, вкажіть порцію 1 шт.',
    'Portion size': 'Розмір порції',
    'Portion price': 'Ціна порції',
    'Critical quantity': 'Критична кількість',
    'Critical quantity hint':
      'Перевіряється окремо на кожному складі: нижче цього значення товар позначається для дозамовлення.',
    Quantity: 'Кількість',
    'Image hint': 'JPG, PNG або WEBP до 5 МБ; показується у списку товарів.',
    Consignment: 'Під реалізацію',
    'Consignment description':
      'Товар залишається власністю постачальника; ви оплачуєте продане за ціною постачальника.',
    Supplier: 'Постачальник',
    'Supplier price': 'Ціна постачальника (за упаковку)',
    'Supplier price hint':
      'Ціна за упаковку, яку встановлює постачальник. Борг за продані або втрачені товари під реалізацію рахується за ціною на цей момент.',
    'Purchase price': 'Закупівельна ціна',
    'Purchase price description':
      'Середня собівартість за упаковку, розрахована за приходами та залишками. Змінюється лише складськими операціями.',
    'Sale price': 'Ціна продажу',
    'In Package': 'В упаковці',
    Product: 'Товар',
    'Kit items': 'Склад набору',
    'Add Kit Item': 'Додати товар',
    'Remove Kit Item': 'Прибрати товар',
    'Kit item search': 'Пошук за назвою або артикулом',
    'Kit price': 'Ціна набору',
  },
};
